import { atom } from 'recoil'

import type { ModalRecipientGroupsState } from 'Pages/RecipientsList/model'

export const modalRecipientGroupsState = atom<ModalRecipientGroupsState>({
  key: 'recipientsList_modalRecipientGroups',

  default: {
    show: false,
    idRecipient: 0,
    contact: '',
    loading: false,
    status: 'initial',
    items: [],
    totalItems: 0,
    pageNumber: 1,
    pageSize: 5,
    orderBy: 'AssignmentDate',
    orderDescending: true,
  },
})
